import { identifyUser } from "@dynatrace/rum-javascript-sdk/api/promises";

const getDtrum = () =>
  (typeof globalThis !== "undefined" && globalThis.dtrum) || null;

const safe = (fn) => {
  try {
    fn();
  } catch (e) {
    // RUM must never break the app
  }
};

// The RUM agent is injected asynchronously, so identifyUser is often called
// (from the auth callback) before the agent has initialized `dtrum`. The
// official SDK's promise API waits for the agent to become ready (10s default)
// and then tags the session. We call it fire-and-forget: it never blocks the
// UI and any failure (agent never loads / times out) is swallowed.
export const identifyRumUser = (userId) => {
  if (!userId) return;
  safe(() => {
    Promise.resolve(identifyUser(String(userId))).catch(() => {
      // RUM must never break the app
    });
  });
};

export const endRumSession = () => {
  const dtrum = getDtrum();
  if (!dtrum || typeof dtrum.endSession !== "function") return;
  safe(() => dtrum.endSession());
};

export const reportRumError = (err) => {
  const dtrum = getDtrum();
  if (!dtrum || typeof dtrum.reportError !== "function") return;
  safe(() => dtrum.reportError(err));
};
